// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__ezIlb","col":"CardReaderDesc_col__1zDL2","label":"CardReaderDesc_label__1xr_z"};